import { render, staticRenderFns } from "./CreditLimitList.vue?vue&type=template&id=6fdfc5ab"
import script from "./CreditLimitList.vue?vue&type=script&lang=js"
export * from "./CreditLimitList.vue?vue&type=script&lang=js"
import style0 from "./CreditLimitList.vue?vue&type=style&index=0&id=6fdfc5ab&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports